<template>
  <div class="d-flex justify-content-center align-items-center page-header bg-dark">
    <div class="text-center">
      <figure class="mx-auto" style="width: 300px; height: 300px;">
        <img alt class="img-fluid" src="svg/taken.svg" />
      </figure>
      <h1 class="page-error">
        <small class="fw-500">
          ¡Algo salió
          <span class="text-gradient">mal</span>!
        </small>
      </h1>
      <h4>
        Estamos trabajando duro para corregir este problema.
        <br />
        <br />Mientras tanto, haga clic <router-link to="/">aquí</router-link> para regresar a casa.
      </h4>
    </div>
  </div>
</template>
<script>
export default {
  name: "not-found",
  bodyClass: "not-found-page"
};
</script>
<style>
.not-found-page .page-header {
  min-height: calc(100vh - 82px);
}

.not-found-page .page-header::after,
.not-found-page .page-header::before {
  content: none;
}

.text-gradient {
  background: linear-gradient(180deg,#4e9e9d 25%,#468d8c 50%,#754e9e 75%,#5c3d7c 100%);
  color: #6ab5b4;
  background-clip: text;
  text-fill-color: transparent;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-shadow: none;
}

@media screen and (max-width: 768px) {
  .not-found-page .page-header {
    min-height: calc(100vh - 131px);
  }
}

@media screen and (max-width: 508px) {
  .not-found-page .page-header {
    min-height: calc(100vh - 149px);
  }
}
</style>
